module.exports = __webpack_public_path__ + "static/img/kosteniuk.898555b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/personas/kosteniuk.jpg
// module id = 485
// module chunks = 11